import expenses from './expenses.js';
import purchasesCreditMemos from './purchases-credit-memos.js';
import purchaseOrders from './purchase-orders.js';
import receivedInvoices from './received-invoices.js';
import recurringExpenses from './recurring-expenses.js';

export default [...expenses, ...purchasesCreditMemos, ...purchaseOrders, ...receivedInvoices, ...recurringExpenses];
